import React from 'react';
import { Database, AlertTriangle, Users, Building, DollarSign, Landmark, ExternalLink } from 'lucide-react';
export function OfficialResources() {
  const resources = [{
    title: 'Open Data Portal',
    desc: 'Access public data and transparency reports',
    icon: Database
  }, {
    title: 'MyLA311',
    desc: 'Report issues: graffiti, potholes, streetlights, illegal dumping',
    icon: AlertTriangle
  }, {
    title: 'EmpowerLA',
    desc: 'LA Department of Neighborhood Empowerment',
    icon: Users
  }, {
    title: 'City Services',
    desc: 'Access City of Los Angeles services',
    icon: Building
  }, {
    title: 'Budget Advocates',
    desc: 'Community budget participation',
    icon: DollarSign
  }, {
    title: 'LA City Council',
    desc: 'District 7 - Council Member Monica Rodriguez',
    icon: Landmark
  }];
  return <section className="py-16 px-6 lg:px-8 bg-charcoal text-white border-t-4 border-sylmar" data-id="element-351">
      <div className="max-w-7xl mx-auto" data-id="element-352">
        <div className="mb-10 text-center md:text-left" data-id="element-353">
          <h2 className="text-2xl md:text-3xl font-bold text-white mb-1" data-id="element-354">
            Recursos Oficiales
          </h2>
          <p className="text-sky font-medium" data-id="element-355">Official Resources</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4" data-id="element-356">
          {resources.map((resource, index) => <a href="#" key={index} className="group flex flex-col bg-charcoal-light/50 p-5 rounded-xl border border-charcoal-light hover:border-sylmar hover:bg-charcoal-light transition-all duration-300" data-id="element-357">
              <div className="flex justify-between items-start mb-4" data-id="element-358">
                <div className="bg-charcoal p-2.5 rounded-lg text-sylmar group-hover:bg-sylmar group-hover:text-white transition-colors" data-id="element-359">
                  <resource.icon className="w-6 h-6" data-id="element-360" />
                </div>
                <ExternalLink className="w-4 h-4 text-gray-400 group-hover:text-white transition-colors" data-id="element-361" />
              </div>
              <h3 className="font-bold text-white mb-2 group-hover:text-sylmar-light transition-colors leading-tight" data-id="element-362">
                {resource.title}
              </h3>
              <p className="text-xs text-gray-400 leading-relaxed flex-grow" data-id="element-363">
                {resource.desc}
              </p>
            </a>)}
        </div>
      </div>
    </section>;
}